import { CriteriaDimension, SortDirection } from '@openx/types/tableCriteria';
import { TABLE_PAGE_SIZE } from '../../../config';
import type { CuratedDealBuyerDiscountApi } from '../../../types/curatedDealBuyerDiscount';
import type { DefaultTableCriteria } from '../../../utils/useListCriteria';

export const curatedDealBuyerDiscountDefaultCriteria: DefaultTableCriteria<'curatedDealBuyerDiscounts'> = {
  [CriteriaDimension.FILTERS]: {
    phrase: '',
  },
  [CriteriaDimension.PAGINATION]: {
    pageNumber: 1,
    pageSize: TABLE_PAGE_SIZE,
    totalCount: 0,
  },
  [CriteriaDimension.SORT]: {
    column: 'name' satisfies keyof CuratedDealBuyerDiscountApi,
    direction: SortDirection.ASC,
    sortableColumns: [
      'banner_and_video_discount',
      'ctv_discount',
      'modified_date',
      'name',
    ] satisfies (keyof CuratedDealBuyerDiscountApi)[],
  },
};
